const RAW_TECHNICAL_PATTERNS = [
  'failed to fetch',
  'network request failed',
  'load failed',
  'network_unavailable',
  'typeerror: network',
  'api-test.mentorcoaching.ai',
  'mentorcoaching.ai/api',
];

export function userFacingErrorKey(raw?: unknown): string {
  const value = String(raw || '').toLowerCase();

  if (RAW_TECHNICAL_PATTERNS.some((pattern) => value.includes(pattern))) {
    return 'errors.connectionUnavailable';
  }
  if (value.includes('server_unavailable') || value.includes('http 500') || value.includes('http_500')) {
    return 'errors.serverUnavailable';
  }
  if (value.includes('upload_file_too_large') || value.includes('payload too large') || value.includes('http 413')) {
    return 'transcription.errors.fileTooLargeGeneric';
  }
  if (value.includes('unsupported_audio_format') || value.includes('unsupported format') || value.includes('http 415')) {
    return 'transcription.errors.unsupportedAudio';
  }
  if (value.includes('auth_expired') || value.includes('unauthorized') || value.includes('http 401')) {
    return 'errors.sessionExpired';
  }
  if (value.includes('rate_limited') || value.includes('too many requests') || value.includes('http 429')) {
    return 'errors.rateLimited';
  }
  if (value.includes('timeout') || value.includes('timed out')) {
    return 'errors.timeout';
  }
  if (value.includes('upload_interrupted')) {
    return 'transcription.errors.uploadInterrupted';
  }

  return 'errors.genericRetry';
}

export function userFacingErrorMessage(
  t: (key: string, defaultOrVars?: string | Record<string, unknown>, vars?: Record<string, unknown>) => string,
  raw?: unknown,
  fallbackKey = 'errors.genericRetry',
): string {
  const key = userFacingErrorKey(raw);
  const fallback = t(fallbackKey);
  return t(key, fallback);
}
